// extracted by mini-css-extract-plugin
export default {"skeleton":"nbmXj","dissolve":"rR5NV"};